import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  FiscalQRBoxContainer,
  FiscalQRBox,
  LegalData,
  LegalLinkContainer,
  LegalLink,
  RegretButton,
  NewBottomFooterContainer,
  Separator,
  DefConsumerCotainer,
  SeparatorHorizontal,
  LogoGQAContainer
} from './styles';
import LayoutContainer from './LayoutContainer';
import GQALogo from '../../../assets/icons/grupoqa_logo.svg';
import NormativaArgentina from '../argentina/NormativaArgentina';

const BottomFooter = ({ fiscalQR, siteNameCom, legalLinks, device }) => {
  const { t } = useTranslation();
  const siteId = process.env.REACT_APP_BUILD_SITE;
  const isZonaProp = siteId === 'ZPAR';
  return (
    <NewBottomFooterContainer data-panel='landingZD-footer-bottonFooter-conteiner'>
      {isZonaProp && (
        <LayoutContainer
          data-panel='landingZD-footer-bottonFooter-layoutContainer-regretbuttonarea'
          extend={{ display: 'flex', flexWrap: 'wrap' }}
          isFullViewport={false}
          ignoreLargeDesktop={false}
        >
          <DefConsumerCotainer>
            <RegretButton
              href='https://docs.google.com/forms/d/e/1FAIpQLSddwlJb5SmJHvn3us9LwNLa0mpQ-pGM4aEi_JTFUzw4HI-cEw/viewform'
              title='boton de arrepentimiento'
              target='_blank'
              rel='noopener noreferrer'
            >
              {t('panel.zonademand.botonArrepentimiento')}
            </RegretButton>
            <NormativaArgentina device={device} />
          </DefConsumerCotainer>
        </LayoutContainer>
      )}
      <LayoutContainer
        data-panel='landingZD-footer-bottonFooter-layoutContainer'
        extend={{ display: 'flex', flexWrap: 'wrap' }}
        isFullViewport={false}
        ignoreLargeDesktop={false}
      >
        {device !== 'mobile' && (
          <>
            <a
              href='https://grupoquintoandar.com/es/'
              target='_blank'
              title='Grupo quinto andar'
              rel='noopener noreferrer'
            >
              <img src={GQALogo} alt='Logo de grupo quinto andar' />
            </a>
            <Separator />
          </>
        )}
        {fiscalQR && (
          <FiscalQRBoxContainer>
            {fiscalQR.map(item => {
              return (
                <FiscalQRBox
                  data-panel={`landingZD-footer-bottonFooter-fiscalQRBox-${item.src}`}
                  href={item.url}
                  key={item.url}
                  device={device}
                >
                  <img src={item.src} alt={item.ariaLabel} aria-label={item.ariaLabel} />
                </FiscalQRBox>
              );
            })}
          </FiscalQRBoxContainer>
        )}

        <LegalData data-panel='landingZD-footer-bottonFooter-legalData'>
          <p>{`© Copyright ${new Date().getFullYear()} ${siteNameCom}`}</p>
          <LegalLinkContainer data-panel='landingZD-footer-bottonFooter-LegalData-linkContainer'>
            {legalLinks?.map(item => {
              if (item) {
                return (
                  <>
                    {item.img && <img src={item.img} alt={item.wording} />}
                    <LegalLink
                      data-panel={`landingZD-footer-bottonFooter-LegalData-linkContainer-link-${item.wording}`}
                      target='_blank'
                      href={item.url}
                      key={item.url}
                      title={item.wording}
                    >
                      {item.wording}
                    </LegalLink>
                  </>
                );
              }
              return null;
            })}
          </LegalLinkContainer>
        </LegalData>
        {device === 'mobile' && (
          <LogoGQAContainer>
            <SeparatorHorizontal />
            <a
              href='https://grupoquintoandar.com/es/'
              target='_blank'
              title='Grupo quinto andar'
              rel='noopener noreferrer'
            >
              <img src={GQALogo} alt='Logo de grupo quinto andar' />
            </a>
          </LogoGQAContainer>
        )}
      </LayoutContainer>
    </NewBottomFooterContainer>
  );
};

export default BottomFooter;
